import React, {
  forwardRef,
  type PropsWithChildren,
  type HTMLAttributes,
} from "react";
import clsx from "clsx";
import { makeStyles, lighten } from "@material-ui/core/styles";
import type { Theme } from "src/theme";
import { useThemeContext } from "src/contexts/ThemeContext";

const useStyles = makeStyles((theme: Theme) => {
  const { custom: palette } = theme.palette.custom;

  return {
    root: {
      borderRadius: "50%",
      backgroundColor: palette.brandPrimary,
      width: "50px",
      height: "50px",
      cursor: "pointer",
      transition: "transform 0.2s ease, background-color 0.2s ease",
      "&:hover": {
        backgroundColor: lighten(palette.brandPrimary, 0.25),
        transform: "scale(1.15)",
      },
    },
  };
});

type IconWrapperProps = PropsWithChildren<{ className?: string }> &
  HTMLAttributes<HTMLDivElement>;

const IconWrapper = forwardRef<HTMLDivElement, IconWrapperProps>(
  ({ children, className, ...props }, ref) => {
    const classes = useStyles();
    const { preferences } = useThemeContext();

    const customBg = preferences.useCustomPalette
      ? { backgroundColor: preferences.customDarkPalette.bg }
      : undefined;

    return (
      <div
        {...props}
        className={clsx(classes.root, className)}
        style={customBg}
        ref={ref}
      >
        {children}
      </div>
    );
  }
);

export default IconWrapper;
